import React from 'react'

const HeaderVerde = (props) => {
    const mediaWeb = window.matchMedia("(min-width:600px)").matches
    const fonte = mediaWeb ? "17px" : "12px"

    const estilo = {
        header: {
            margin: "auto", marginTop: "20px", marginBottom: "1vh", 
            color: "#087C4A", fontWeight: "bold", fontSize: fonte
        }
    }
    return (
        <>
            <div style={estilo.header}>{props.texto}</div>
        </>
    )
}

export default HeaderVerde